// src/api/timesheets.js

import {get, post, patch, postFormData} from "@/lib/fetcher"

/**
 * Fetch a single timesheet from the API by job slug
 */

export async function getCandidateTerms(){
    return await get ('/candidates/candidate_terms')
}

export async function patchCandidateTerm(id){
    return await patch ('/candidates/candidate_terms', id, {} )
}

